import type { Workspace } from '../shared/models/Workspace'

export function canWriteWorkspace(workspace: Workspace | undefined, username: string | undefined, isAdmin: boolean) {
  const email = username?.trim().toLowerCase()
  return Boolean(
    email &&
    workspace &&
    (isAdmin ||
      workspace.createdBy.trim().toLowerCase() === email ||
      workspace.users?.some(
        (user) => user.email.trim().toLowerCase() === email && user.permission === 'write',
      )),
  )
}
